import React, { useState, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { configdata, createTextFileApi, indicatorlist, RoleandMapping, OwnershipApi, ListAlldept, Getlocations } from "../components/ApiProperty";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import formStyles from '../assets/css/gapsy-form.module.css';
import { BiSortUp, BiSortDown, BiSort } from "react-icons/bi";
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { tableCellStyle2, UsersPagination } from "../components/TableProperty";
import { Modal, Button } from 'react-bootstrap';
import { SearchBox, UploadLoadingIcon } from "../components/Propertyfile";

const GapsyParameterMapping = () => {
    const [activeTab, setActiveTab] = useState('ldap'); // 'manual' or 'ai'
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const usersItemsPerPage = 7; // Set the number of items per page
    const navigate = useNavigate();
    const [userPerPage, setUsersPerPage] = useState(1); // Set the initial page to 1
    const [showModalLdap, setShowModalLdap] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [checkerData, setCheckerData] = useState(null);
    const [message, setMessage] = useState("");
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'warning', or 'error'
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [modalMessage3, setModalMessage3] = useState('');
    const [pendingPayload, setPendingPayload] = useState(null); // store request for retry

    const [selectedOption, setSelectedOption] = useState('All');
    const [disableInputs, setDisableInputs] = useState(false);
    const [passwordGenerated, setPasswordGenerated] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedLocationValues, setSelectedLocationValues] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showAllowUploadPopup, setShowAllowUploadPopup] = useState(false);
    const [showNoRecordsModal, setShowNoRecordsModal] = useState(false);
    const [mode, setMode] = useState("");
    const [selectedConfig, setSelectedConfig] = useState("");
    const [selectedRiskIndicators, setSelectedRiskIndicators] = useState([]);
    const [indicatorMap, setIndicatorMap] = useState({});

    const [departments, setDepartments] = useState([]); // Initialize as empty array
    const [formData, setFormData] = useState({
        adminId: '',
        userId: '',
        userName: '',
        userRole: '',
        departments: '',
        departmentname: '',
        userRole: '',
        orgHierarchy: '',
        userLocation: '',
        active_yn: '',
        mappedId: '',
        searchUserId: '' // Add this line
    });
    const [initialData, setInitialData] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userId', direction: 'asc' });
    const [error, setError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedChecker, setSelectedChecker] = useState('');

    let csrfToken = sessionStorage.getItem("tokenizedSession");



    const dept = sessionStorage.getItem("dept");

    useEffect(() => {
        fetchUsers();
    }, []);

    useEffect(() => {
        const fetchIndicators = async () => {
            try {
                setIsLoading(true);
                const config = {
                    params: { "adminId": localStorage.getItem('userid'), dept: dept },
                    headers: {
                        'x-csrf-token': csrfToken,
                    },
                    withCredentials: true
                }
                const response = await axios.post(indicatorlist, {}, config);
                console.log("Indicatorlist API Response:", response.data);

                setIndicatorMap(response.data.data);

            } catch (error) {
                console.error("Error fetching Indicatorlist:", error);
                setIndicatorMap([]);
            }
        };
        fetchIndicators();
    }, []);


    // const getIndicatorKey = (config) => {
    //     if (!config) return "";

    //     if (config === "Pillar1") return "Pillar1";
    //     if (config === "Pillar2") return "Pillar2";

    //     if (config.includes("Daily")) return "Daily";
    //     if (config.includes("Monthly")) return "Monthly";
    //     if (config.includes("Quarterly")) return "Quarterly";

    //     if (config === "Critical") return "Critical";

    //     return "";
    // };

    const getIndicatorKey = (config, parameterName) => {
        if (!config && !parameterName) return "";

        // 👇 HANDLE CUSTOM / UNKNOWN PARAMS → USE CRITICAL
        const knownConfigs = [
            "Pillar1",
            "Pillar2",
            "Top5-Daily",
            "Top5-Monthly",
            "Top5-Quarterly",
            "Watchlist-Daily",
            "Watchlist-Monthly",
            "Watchlist-Quarterly",
            "Critical"
        ];

        // If it's not in known list → treat as Custom → use Critical
        if (!knownConfigs.includes(config)) {
            return "Critical";
        }

        if (config === "Pillar1") return "Pillar1";
        if (config === "Pillar2") return "Pillar2";

        if (config.includes("Daily")) return "Daily";
        if (config.includes("Monthly")) return "Monthly";
        if (config.includes("Quarterly")) return "Quarterly";

        if (config === "Critical") return "Critical";

        return "";
    };

    // const filteredIndicators = indicatorMap[getIndicatorKey(selectedConfig)] || [];
    const filteredIndicators =
        indicatorMap[getIndicatorKey(selectedConfig, formData.parameterName)] || [];

    const configNames = [
        "Pillar1",
        "Pillar2",
        "Top5-Daily",
        "Top5-Monthly",
        "Top5-Quarterly",
        "Watchlist-Daily",
        "Watchlist-Monthly",
        "Watchlist-Quarterly",
        "Critical"
    ];

    const handleCancelUpload = () => {
        setShowAllowUploadPopup(false);
        setPendingPayload(null);
    };

    const handleForceUpload = async () => {
        try {
            setShowAllowUploadPopup(false);
            setIsLoading(true);

            const responseDb = await submitLdapData('Y'); // second call

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Update failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while updating');
        } finally {
            setIsLoading(false);
            setPendingPayload(null);
        }
    };

    const submitLdapData = async (allowUpdate = '') => {
        const adminId = localStorage.getItem('userid') || '';

        const normalizedConfig = selectedConfig.replace(/\s+/g, '');
        console.log("Normalized config name:", normalizedConfig);

        const jsonData = {
            configName: selectedConfig, // keep original for DB
            riskIndicators: selectedRiskIndicators
        };

        const content = JSON.stringify(jsonData, null, 2);

        // ✅ USE normalized name everywhere
        const filename = `${normalizedConfig}_config.json`;
        console.log("Generated filename:", filename);

        // Step 1
        await axios.post(
            createTextFileApi,
            { filename, content },
            {
                headers: {
                    'Content-Type': 'application/json',
                    userId: adminId,
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true,
            }
        );

        // Step 2
        const config = {
            headers: {
                userId: adminId,
                "x-csrf-token": csrfToken
            },
            withCredentials: true,
            params: {
                filePath: `/saswork/nas/${filename}`, // ✅ now correct
                Notifications: "IN",
                dept: dept,
                configName: selectedConfig,
                allowUpdate: allowUpdate
            }
        };

        return await axios.post(configdata, {}, config);
    };

    const handleLdapSubmit = async (e) => {
        e.preventDefault();

        try {
            const adminId = localStorage.getItem('userid') || '';

            // Correct validation based on current UI
            if (!selectedConfig) {
                setMessageType('error');
                setModalMessage("Parameter is required");
                return;
            }

            if (selectedRiskIndicators.length === 0) {
                setMessageType('error');
                setModalMessage("Risk Indicators are required");
                return;
            }
            setIsLoading(true);

            const responseDb = await submitLdapData(); // first call

            if (responseDb.data?.status?.toLowerCase() === 'update') {

                // 🔥 store state for retry
                setPendingPayload(true);

                setModalMessage3(`
                    ${selectedConfig}:
                    Existing Risk Indicators: ${responseDb.data.existingRiskIndicator}<br/>
                    Do you want to update?
                `);

                setShowAllowUploadPopup(true);
                return;
            }

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while processing request');
        } finally {
            setIsLoading(false);
        }
    };

    const fetchUsers = async () => {
        try {
            // setIsLoading(true);

            const config = {
                params: {
                    adminId: localStorage.getItem('userid'),
                    tableName: "param_indicator"
                },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            };

            const response = await axios.post(RoleandMapping, {}, config);

            const apiData = (response.data.data || []).map(item => ({
                parameterName: item.PARAMETER_NAME,
                riskIndicator: item.RISK_INDICATOR
            }));

            setUsers(apiData);
            setFilteredUsers(apiData);

        } catch (error) {
            console.error('Error fetching users!', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchOwnership = async () => {
        try {
            // setIsLoading(true);
            const config = {
                params: { "adminId": localStorage.getItem('userid'), ownership: "Y" },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            }
            const response = await axios.post(OwnershipApi, {}, config);
            console.log("Ownership API Response:", response.data);

            // Extract Ownership array
            const ownershipList = response.data?.Ownership || [];
            console.log("Fetched Ownership List:", ownershipList);

            setDepartments(ownershipList);

        } catch (error) {
            console.error("Error fetching departments:", error);
            setDepartments([]);
        }
    };

    useEffect(() => {
        fetchOwnership();
    }, []);


    // useEffect(() => {
    //     const fetchDepartments = async () => {
    //         const sessionDept = sessionStorage.getItem("dept");

    //         try {
    //             // Fetch all departments for everyone
    //             const deptConfig = {
    //                 headers: {
    //                     userId: localStorage.getItem('userid'),
    //                     'x-csrf-token': csrfToken,
    //                 },
    //                 withCredentials: true
    //             };

    //             const response = await axios.post(ListAlldept, {}, deptConfig);

    //             if (response.data?.department && Array.isArray(response.data.department)) {
    //                 const allDepartments = response.data.department.map((name, index) => ({
    //                     id: index + 1,
    //                     name
    //                 }));

    //                 if (sessionDept === "IT") {
    //                     // IT users see all departments
    //                     setDepartments(allDepartments);
    //                 } else {
    //                     // Non-IT users see all departments but their own department is selected by default
    //                     setDepartments(allDepartments);

    //                     // Set their department as the initial value in the form
    //                     setFormData(prev => ({
    //                         ...prev,
    //                         orgHierarchy: sessionDept
    //                     }));
    //                 }
    //             } else {
    //                 // Fallback to just their department if API fails
    //                 setDepartments([{ id: 1, name: sessionDept }]);
    //                 setFormData(prev => ({
    //                     ...prev,
    //                     orgHierarchy: sessionDept
    //                 }));
    //             }
    //         } catch (error) {
    //             console.error('Error fetching departments:', error);
    //             // Fallback to just their department if API fails
    //             setDepartments([{ id: 1, name: sessionDept }]);
    //             setFormData(prev => ({
    //                 ...prev,
    //                 orgHierarchy: sessionDept
    //             }));
    //         }
    //     };

    //     fetchDepartments();
    // }, []);


    const handleShow = (isEdit = false, mode) => {
        if (!isEdit) {
            setFormData({ adminId: '', userId: '', userFirstName: '', userLastName: '', userEmail: '', userPassword: '', userRole: '', orgHierarchy: '', userLocation: '', active_yn: '', mappedId: '' });
            setInitialData(users);
            setEditIndex(isEdit);
        }
        setError(null);
        setMode(mode);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setModalMessage('');
        setMessageType('');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };


    const handleRoleChange = (e) => {
        const newRole = e.target.value;

        // Clear mappedId if changing from Checker to Maker
        if (selectedRole === 'Checker' && newRole === 'Maker') {
            localStorage.removeItem('mappedId');
        }

        setFormData({
            ...formData,
            userRole: newRole,
        });
        setSelectedRole(newRole);
    };

    // const handleCloseLdap = () => {
    //     setModalMessage('');
    //     setModalMessage3('');
    //     setShowModalLdap(false);
    //     // setFormData({ userName: '', userId: '', userRole: '', departmentname: '', departments: '', userPassword: '', userRole: '', orgHierarchy: '', userLocation: '', active_yn: '', mappedId: '' });
    //     setInitialData({});
    //     setEditIndex(null);
    //     setMessage('');
    // };

    const handleCloseLdap = () => {
        setModalMessage('');
        setModalMessage3('');
        setShowModalLdap(false);

        setInitialData({});
        setEditIndex(null);
        setMessage('');

        // ✅ REFRESH TABLE
        fetchUsers();
    };

    const handleFocus = (e) => {
        const { name } = e.target;
        if (!validateField(name)) {
            e.preventDefault();
        }
    };
    // const handleHierarchyChange = async (hierarchyValue) => {
    //     // Update form state
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         orgHierarchy: hierarchyValue,
    //     }));

    //     // Update hierarchy state
    //     setHierarchy(hierarchyValue);

    //     try {
    //         // 1. First API call - Fetch locations
    //         const locationResponse = await fetch(Getlocations, {
    //             method: 'POST',
    //             headers: {
    //                 'x-csrf-token': csrfToken // if needed
    //             },
    //         });
    //         if (!locationResponse.ok) {
    //             throw new Error('Failed to fetch location data');
    //         }

    //         const locationData = await locationResponse.json();
    //         // setSelectedLocationValues(locationData.location || []);
    //         setSelectedLocationValues(Array.isArray(locationData.location) ? locationData.location : []);

    //         // 2. Second API call - Fetch list of checkers (only if hierarchyValue means which we selected in dropdown)
    //         if (hierarchyValue) {
    //             const config = {
    //                 params: {
    //                     "adminId": localStorage.getItem('userid'),
    //                     "dept": hierarchyValue
    //                 },
    //                 headers: {
    //                     'x-csrf-token': csrfToken,
    //                 },
    //                 withCredentials: true
    //             };
    //             const checkersResponse = await axios.post(List_Checker, {}, config);
    //             setCheckerData(checkersResponse.data.checkers_list);

    //         }
    //     } catch (error) {
    //         console.error('Error in handleHierarchyChange:', error.message);
    //         setSelectedLocationValues([]);
    //         setCheckerData([]); // Reset checkers data on error
    //     }
    // };

    const handleCheckers = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        setSelectedChecker(e.target.value);
    };

    const handleUserStatus = (e) => {
        setFormData({
            ...formData,
            active_yn: e.target.value,
        });
        setSelectedStatus(e.target.value);
    };

    const validateField = (fieldName) => {
        if (fieldName === 'userFirstName' && !formData.userId) {
            setError('User Id is required');
            return false;
        }
        if (fieldName === 'userEmail' && !formData.userId) {
            setError('User Name is required');
            return false;
        }
        if (fieldName === 'userPassword' && !formData.userId) {
            setError('User Password is required');
            return false;
        }
        // Clear error message if validation passes
        setError(null);
        return true;
    };

    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyAdashboard');
        // Additional logic if needed
    };

    const handleAddRow = (e) => {
        e.preventDefault();
        navigate('/gapsyuserconfig');
        // Additional logic if needed
    };

    const validateEmail = (inputEmail) => {
        // Regular expression for basic email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(inputEmail);
    };

    const getSortedAndFilteredUsers = () => {
        if (!Array.isArray(filteredUsers)) return [];  //  safety

        return [...filteredUsers].sort((a, b) => {
            if (a.newlyCreated && !b.newlyCreated) return -1;
            if (!a.newlyCreated && b.newlyCreated) return 1;

            const aValue = typeof a[sortConfig.key] === 'string'
                ? a[sortConfig.key].toLowerCase()
                : a[sortConfig.key];

            const bValue = typeof b[sortConfig.key] === 'string'
                ? b[sortConfig.key].toLowerCase()
                : b[sortConfig.key];

            if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;

            return 0;
        });
    };

    const sortedAndFilteredUsers = getSortedAndFilteredUsers();


    const handleReset = () => {
        if (!initialData || !initialData.parameterName) return;

        setFormData({
            parameterName: initialData.parameterName || "",
            riskIndicator: initialData.riskIndicator || ""
        });

        // ✅ ALSO reset checkbox selection
        const indicatorsArray = initialData.riskIndicator
            ? initialData.riskIndicator.split(',').map(i => i.trim())
            : [];

        setSelectedRiskIndicators(indicatorsArray);

        // ✅ keep config in sync
        setSelectedConfig(initialData.parameterName);
    };

    const handleEdit = (parameterName, mode) => {
        if (!parameterName) return;

        const index = sortedAndFilteredUsers.findIndex(
            item => item.parameterName === parameterName
        );

        if (index !== -1) {
            const selectedItem = sortedAndFilteredUsers[index];

            const indicatorsArray = selectedItem.riskIndicator
                ? selectedItem.riskIndicator.split(',').map(i => i.trim())
                : [];

            // ✅ IMPORTANT ORDER
            setSelectedConfig(selectedItem.parameterName);   // 1️⃣
            setSelectedRiskIndicators(indicatorsArray);      // 2️⃣

            setFormData({
                parameterName: selectedItem.parameterName,
                riskIndicator: selectedItem.riskIndicator
            });

            setInitialData(selectedItem);
            setEditIndex(index);
            setMode(mode);
            handleShow(true, mode);
        }
    };

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <BiSort />;  // Neutral/no sort icon
        }
        return sortConfig.direction === 'ascending'
            ? <BiSortUp />
            : <BiSortDown />;
    };
    const renderUsersTable = () => {
        const startIndex = (userPerPage - 1) * usersItemsPerPage;

        const paginatedTableData = sortedAndFilteredUsers.slice(
            startIndex,
            startIndex + usersItemsPerPage
        );

        return paginatedTableData.map((data, index) => (
            <tr key={index}>
                <td>
                    <i
                        className='p-1 bi bi-pencil'
                        onClick={() => handleEdit(data.parameterName, "edit", false)}
                        title="Edit"
                        style={{ cursor: 'pointer' }}
                    ></i>
                </td>
                <td style={{ ...tableCellStyle2(startIndex), textAlign: "left" }}>
                    {data.parameterName}
                </td>
                <td style={{ ...tableCellStyle2(startIndex), textAlign: "left" }}>
                    {data.riskIndicator}
                </td>

            </tr>
        ));
    };

    // const renderUsersTable = () => {
    //     const startIndex = (userPerPage - 1) * usersItemsPerPage;
    //     const paginatedTableData = sortedAndFilteredUsers.slice(startIndex, startIndex + usersItemsPerPage);

    //     return paginatedTableData
    //         .filter((data) => data && data.userId) // Filter out undefined or null data
    //         .map((data) => (
    //             <tr
    //                 key={data.userId}
    //                 className={`${data.newlyCreated ? 'bg-success text-white' : ''}`}
    //                 style={{
    //                     transition: 'background-color 0.3s ease',
    //                 }}
    //             >
    //                 <td style={tableCellStyle2(startIndex)}>
    //                     {data.userId}
    //                 </td>
    //                 <td style={tableCellStyle2(startIndex)}>
    //                     {data.userName}
    //                 </td>
    //                 <td style={tableCellStyle2(startIndex)}>
    //                     {data.userRole}
    //                 </td>
    //                 <td style={tableCellStyle2(startIndex)}>
    //                     {data.departmentname}
    //                 </td>



    //                 {/* <td style={tableCellStyle2(startIndex)}>
    //                     <i
    //                         className={`bi ${data.active_yn && data.active_yn.trim().toUpperCase() === 'Y' ? 'bi-toggle-on text-success' : 'bi-toggle-off text-danger'}`}
    //                         // onClick={() => handleToggle(data.userId)}
    //                         style={{ fontSize: '18px' }}
    //                     ></i>
    //                 </td> */}
    //                 <td style={{ width: '10%' }}>
    //                     <i
    //                         className='p-1 bi bi-pencil'
    //                         onClick={() => handleEdit(data.parameterName, "edit", false)}
    //                         title="Edit"
    //                         style={{ cursor: 'pointer' }}
    //                     ></i>
    //                 </td>
    //             </tr>
    //         ));
    // };

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = users.filter(item => {
            const param = item.parameterName?.toLowerCase() || "";
            const risk = item.riskIndicator?.toLowerCase() || "";

            return param.includes(query) || risk.includes(query);
        });

        setFilteredUsers(filtered.length ? filtered : users);
        setUsersPerPage(1);
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-person-plus me-2"></i>RAF - Reports Parameters
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 mx-auto">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">

                                        {/* Header + Search Row with single underline */}
                                        <div className={`d-flex justify-content-between align-items-center pb-2 mb-2 ${styles.borderBottom}`}>

                                            {/* Left: Heading */}
                                            <h6 className="mb-0">RAF - Reports Parameters</h6>

                                            {/* Right: Search Box */}
                                            <div className="d-flex flex-wrap gap-3">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={handleAddRow}
                                                    title="Add New Parameter"
                                                >
                                                    <i className="bi bi-plus" style={{ fontSize: '14px' }}></i>
                                                </button>
                                                <SearchBox searchTerm={searchQuery} handleSearch={handleSearch} />
                                            </div>
                                        </div>
                                        {/* Table */}
                                        {/* {isLoading ? (
                                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                                <UploadLoadingIcon />
                                            </div>
                                        ) : ( */}
                                        <div className="table-on-homepage-only mb-3">
                                            <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                    <thead className="sticky-header">
                                                        {selectedOption !== 'All' && (
                                                            <tr className="rowFilter">
                                                                <td colSpan="6">Applied Filter : {selectedOption}</td>
                                                            </tr>
                                                        )}
                                                        <tr>
                                                            <th>Modify</th>
                                                            <th>Parameter Name</th>
                                                            <th>Risk Indicator</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>{renderUsersTable()}</tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* )} */}


                                        {/* Pagination */}
                                        <div className="d-flex justify-content-end">
                                            <UsersPagination
                                                currentPage={userPerPage}
                                                itemsPerPage={usersItemsPerPage}
                                                totalItems={sortedAndFilteredUsers.length}
                                                onPageChange={setUsersPerPage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="">
                                            <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>Modify RAF - Reports Parameters</h6>
                                            <div className={`mx-auto ${formStyles.formWrapper}`}>

                                                {mode === "edit" ? (
                                                    <form onSubmit={handleLdapSubmit}>

                                                        {/* PARAMETER NAME */}
                                                        <div className="form-group row mb-2">
                                                            <label className="col-sm-3 col-form-label small text-muted">
                                                                Parameter Name
                                                            </label>
                                                            <div className="col-sm-8">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    name="parameterName"
                                                                    value={formData.parameterName || ""}
                                                                    onChange={handleChange}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* RISK INDICATOR */}
                                                        <div className="form-group row mb-2">
                                                            <label className="col-sm-3 col-form-label small text-muted">
                                                                Risk Indicator
                                                            </label>

                                                            <div className="col-sm-8">
                                                                <div className="dropdown">
                                                                    <button
                                                                        className="btn btn-light btn-sm dropdown-toggle w-100 text-start text-truncate"
                                                                        type="button"
                                                                        data-bs-toggle="dropdown"
                                                                        style={{
                                                                            overflow: "hidden",
                                                                            whiteSpace: "nowrap",
                                                                            textOverflow: "ellipsis"
                                                                        }}
                                                                    >
                                                                        {selectedRiskIndicators.length > 0
                                                                            ? selectedRiskIndicators.join(", ")
                                                                            : "Select Risk Indicator"}
                                                                    </button>

                                                                    <ul
                                                                        className="dropdown-menu w-100"
                                                                        style={{ maxHeight: "200px", overflowY: "auto" }}
                                                                    >
                                                                        {filteredIndicators.map((indicator, index) => (
                                                                            <li key={index} className="px-2">
                                                                                <div className="form-check">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        id={`indicator-${index}`}
                                                                                        checked={selectedRiskIndicators.some(
                                                                                            i => i.trim().toLowerCase() === indicator.trim().toLowerCase()
                                                                                        )}
                                                                                        onChange={(e) => {

                                                                                            const top5Configs = [
                                                                                                "Top5-Daily",
                                                                                                "Top5-Monthly",
                                                                                                "Top5-Quarterly"
                                                                                            ];

                                                                                            const maxLimit = top5Configs.includes(selectedConfig) ? 5 : 7;

                                                                                            if (e.target.checked) {

                                                                                                if (selectedRiskIndicators.length >= maxLimit) {
                                                                                                    setMessageType('error');
                                                                                                    setModalMessage(`Maximum ${maxLimit} Risk Indicators allowed`);
                                                                                                    return;
                                                                                                }

                                                                                                setSelectedRiskIndicators([
                                                                                                    ...selectedRiskIndicators,
                                                                                                    indicator
                                                                                                ]);

                                                                                            } else {
                                                                                                setSelectedRiskIndicators(
                                                                                                    selectedRiskIndicators.filter(i => i !== indicator)
                                                                                                );
                                                                                            }
                                                                                        }}
                                                                                    />

                                                                                    <label
                                                                                        className="form-check-label"
                                                                                        title={indicator}
                                                                                        htmlFor={`indicator-${index}`}
                                                                                        style={{
                                                                                            whiteSpace: "nowrap",
                                                                                            overflow: "hidden",
                                                                                            textOverflow: "ellipsis",
                                                                                            display: "block"
                                                                                        }}
                                                                                    >
                                                                                        {indicator}
                                                                                    </label>
                                                                                </div>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* BUTTONS */}
                                                        <div className="form-group row mt-2">
                                                            <div className="col-sm-4"></div>
                                                            <div className="col-sm-7 d-flex">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary me-2 flex-grow-1"
                                                                    onClick={handleReset}
                                                                >
                                                                    Reset
                                                                </button>

                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-sm btn-primary flex-grow-1"
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </form>
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <p className="text-muted small">Select a parameter to modify</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {showAllowUploadPopup && (
                                <Modal show onHide={handleCancelUpload} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                    <Modal.Header style={{ backgroundColor: '#366872', color: 'white', padding: '0.5rem 1rem' }}>
                                        <Modal.Title style={{ fontSize: '16px' }}>Confirmation</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                        /* <sttong>{toTitleCase(editableTableName)}</sttong> Template is already exists. Do you wish to upload data with the same template? */
                                        dangerouslySetInnerHTML={{
                                            __html: modalMessage3.replace(/\n/g, '<br />')
                                        }}>
                                    </Modal.Body>
                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button variant="secondary" onClick={handleCancelUpload}>No</Button>
                                        <Button variant="primary" onClick={handleForceUpload}>Yes</Button>
                                    </Modal.Footer>
                                </Modal>
                            )}

                            {/* Modal for messages */}
                            <Modal
                                show={!!modalMessage}
                                onHide={handleCloseModal}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: '12vh' }}
                            >
                                <div
                                    className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                    role="alert"
                                    style={{ marginBottom: '0' }}
                                >
                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                                        ) : messageType === 'warning' ? (
                                            <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                display: 'inline',
                                                marginBottom: '0px',
                                                color: messageType === 'success'
                                                    ? 'green'
                                                    : messageType === 'warning'
                                                        ? '#ffc107'
                                                        : 'red'
                                            }}
                                        >
                                            {modalMessage}
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleCloseLdap}
                                        style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                    />
                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyParameterMapping;
